"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CookiesCategory = void 0;
var CookiesCategory;
(function (CookiesCategory) {
    CookiesCategory["STRICTLY_NECESSARY"] = "C0001";
    CookiesCategory["PERFORMANCE"] = "C0002";
    CookiesCategory["FUNCTIONAL"] = "C0003";
    CookiesCategory["TARGETING"] = "C0004";
    CookiesCategory["SOCIAL_MEDIA"] = "C0005";
    CookiesCategory["VIDEO"] = "VID1";
})(CookiesCategory = exports.CookiesCategory || (exports.CookiesCategory = {}));
